module.exports = __webpack_public_path__ + "media/images/flags/1x1/tuv-d76db8b27bf90ffa8f627d9b425543ca.svg";